import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PageHero from "../components/child/PageHero";
import PhonebookLayer from "../components/PhonebookLayer";

const PhonebookList = () => (
  <MasterLayout>
    <PageHero
      title="Contacts"
      subtitle="Organize phonebooks and contact lists for campaigns and messaging."
      badge={{ icon: "mdi:account-box-outline", label: "Phonebooks" }}
    />
    <PhonebookLayer />
  </MasterLayout>
);

export default PhonebookList;
